<script>
  // core components
  import RoleView from "../../viewsERP/Role.svelte";
</script>

<div class="flex flex-wrap mt-4">
  <div class="w-full mb-12 px-4">
    <RoleView />
  </div>
</div>